import querystring from 'querystring';

/**
 * Takes in an object and generates a query string
 * @param {*} obj object data
 */
export function toQueryString(obj) {
  return querystring.stringify(obj);
}

/**
 * Takes in a valid query string and generates an object
 * @param {*} str querystring from url
 */
export function fromQueryString(str) {
  return querystring.parse(str);
}

/**
 * Takes in an object and generates a lower-cased querystring value
 * @param {*} obj object data
 */
export function normalizeQueryString(obj) {
  return toQueryString(obj).toLowerCase();
}

export function getQueryParamsFromLocation(location) {
  const query = location?.search?.substring(1);
  return query ? fromQueryString(query) : {};
}
